
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function SvgIconCaretRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.293 5L1.499 2.206V7.79L4.293 5zm1.415-.707c.39.391.39 1.025 0 1.416l-4 4a.996.996 0 01-1.09.216A1 1 0 01-.002 9V1a1.004 1.004 0 011.71-.71l4 4v.003z",
    fill: "currentColor"
  })));
}

export { SvgIconCaretRight as default };
//# sourceMappingURL=icon-caret-right.svg.js.map
